import { setBuyerDocumentTypes } from './actions';
import { getBuyerDocumentTypes } from '@/services/buyer-dashboard';

export const loadBuyerDocumentTypes = async (dispatch) => {
    const data = await getBuyerDocumentTypes();
    dispatch(setBuyerDocumentTypes(data));
};